import { render } from "./EducationItem.vue?vue&type=template&id=4ec79a88&scoped=true&lang=true"
import script from "./EducationItem.vue?vue&type=script&lang=js"
export * from "./EducationItem.vue?vue&type=script&lang=js"

import "./EducationItem.vue?vue&type=style&index=0&id=4ec79a88&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec79a88"]])

export default __exports__